import Ripple from 'vue-ripple-directive'
import ProfileApis from '@/services/apis/profile'
import { alphanumeric } from '@/mixins/alphanumeric'

const userProfile = new ProfileApis()
export default {
  directives: {
    Ripple,
  },
  mixins: [alphanumeric],
  data() {
    return {
      pending: false,
      notification: {
        login: {
          name: 'login',
          status: false,
        },
        ticket: {
          name: 'ticket',
          status: false,
        },
        announcements: {
          name: 'announcements',
          status: false,
        },
      },
    }
  },
  computed: {
    profileNotification() {
      return this.$store.state.profile.profileInfo.notification
    },
  },
  watch: {
    profileNotification(val) {
      if (val) {
        this.notification = {
          login: {
            name: 'login',
            status: val.login,
          },
          ticket: {
            name: 'ticket',
            status: val.ticket,
          },
          announcements: {
            name: 'announcements',
            status: val.announcement,
          },

        }
      }
    },
  },
  methods: {
    async submit() {
      this.pending = true
      const data = {
        notification: this.notification,
      }

      await userProfile.saveNotification(data).then(res => {
        this.$swal({
          title: res.data.message,
          icon: 'success',
          timer: 2500,
          showConfirmButton: false,
        })
        this.pending = false
        userProfile.get()
      }).finally(() => {
        this.pending = false
      })
    },
  },
}
